import type { NamedFieldProps } from "./Field.js";
import { ColorSchema, OptionalSchema, getOptionalColor, getOptionalSource, getSource } from "shelving";
import { Field, useField } from "./Field.js";
import { FieldNotice } from "./FieldNotice.js";

export function ColorField(props: NamedFieldProps): React.ReactElement {
	const field = useField<string | null>(props);
	const { name, form, schema, value, fullplaceholder } = field;
	getSource(ColorSchema, schema);
	const color = getOptionalColor(value);
	const required = !getOptionalSource(OptionalSchema, schema);
	const onValue: React.FormEventHandler<HTMLInputElement> = ({ currentTarget }) => form.publish(name, currentTarget.value);
	return (
		<Field {...field}>
			<input //
				name={name}
				type="color"
				className="input space-none"
				placeholder={fullplaceholder}
				defaultValue={color?.hex || "#000000"}
				required={required}
				onInput={onValue}
				onChange={onValue}
			/>
			<FieldNotice name={name} />
		</Field>
	);
}
